<template>
    <div class="alert-list table-responsive text-center mt-2">
        <table class="table table-striped table-sm">
            <thead class="bg-hub-primary text-white sticky-top">
                <tr>
                    <th class="text-left" style="width: 30%">Name</th>
                    <th style="width: 20%">Extension</th>
                    <th style="width: 50%">Play</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="alert in filtered_alerts" :key="alert.alert_id">
                    <td class="text-left align-middle">{{ alert.name }}</td>
                    <td class="align-middle">
                        <span v-if="alert.extension !== 0">{{ alert.extension }}</span>
                        <span v-else>N/A</span>
                    </td>
                    <td class="align-middle" style="height: 60px">
                        <a class="btn btn-sm w-100 h-100 p-0" @click="executeAlert(alert)">
                            <i class="fa fa-play fa-fw h-100 pt-3" style="font-size: 20px" aria-hidden="true"></i> 
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            alerts: 'allAlerts',
            scoped_site_id: 'scopedSiteId',
        }),
        filtered_alerts: function () {
            return this.alerts.filter(alert => alert.site_id === this.scoped_site_id)
        }
    },
    created() {
        this.$store.dispatch('setDisabledChangeScopedSite', false)
        this.$store.dispatch('getAlerts')
    },
    methods: {
        executeAlert(alert) {
            if(confirm(`You are about to activate an alert (${alert.name}). Continue?`)) {
                this.$store.dispatch('executeAlert', alert.alert_id);
            }
        }
    }
}
</script>

<style>
.alert-list {
    max-height: 45vh;
    border: 1px solid #ccc;
}
</style>